module.exports = __webpack_public_path__ + "img/IM.1e1576e6.png";